import { StrategyIndicator } from 'model/modules/strategies/strategies';
import AppCard from 'presentation/components/shared/card/AppCard';
import GridHeading from 'presentation/components/shared/grid/GridHeading';
import SliderValue from 'presentation/components/shared/SliderValue';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  data: StrategyIndicator[];
}

const StrategyIndicatorsCard: FC<Props> = ({ data }) => {
  const { t } = useTranslation();

  const gapBetweenSliders = 20;
  const sliderWidth = `calc((100% - ${gapBetweenSliders}px) / 2)`;

  return (
    <>
      <GridHeading>{t('strategyIndicators')}</GridHeading>
      <AppCard p="20px" display="flex" flexWrap="wrap" justifyContent="space-between">
        {data.map((indicator, index) => {
          return (
            <SliderValue
              key={index}
              w={sliderWidth}
              label={indicator.label}
              value={indicator.value}
            />
          );
        })}
      </AppCard>
    </>
  );
};

export default StrategyIndicatorsCard;
